import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import { listarTarefas } from '../../services/tasks'
import '../../styles/menuopcoes.css'
import SubMenuOpcoes from '../SubMenuOpcoes'

function MenuTarefas(props: menuOpcoes) {

    const { atualizarInformacoes } = useContext(ModalEstadoContext)

    const { search } = useLocation()
    const paramsUrl = new URLSearchParams(search)

    const idProjeto = paramsUrl.get("idProjeto")
    const grupo = paramsUrl.get("grupo")

    const [subMenu, setSubMenu] = useState(false)
    const [minhasTarefas, setMinhasTarefas] = useState(0)
    const [minhasSolicitacoes, setMinhasSolicitacoes] = useState(0)
    const [aguardandoAprovarTarefas, setAguardandoAprovarTarefas] = useState(0);

    const data = new Date()

    const ano = data.getFullYear()
    const qtnDias = new Date(data.getFullYear(), data.getMonth() + 1, 0).getDate()
    const dataAnterior = new Date(new Date().setDate(new Date().getDate() - 60))

    const dataInicial = `${dataAnterior.getFullYear()}-${(dataAnterior.getMonth() + 1).toString().padStart(2, '0')}-01`
    const dataFinal = `${ano}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${qtnDias}`

    const usuarioLogado = localStorage.getItem('usuarioGesttor')

    function exibirSubmenu() {
        setSubMenu(subMenu => !subMenu)
    }

    useEffect(() => {
        if (!idProjeto) {
            toast.error('Falha ao Localizar o Projeto');
            return;
        }

        if (!usuarioLogado) return;

        const paramsList = [
            {
                idProjeto,
                pagina: 1,
                titulo: '',
                descricao: '',
                responsavel: '',
                situacao: '',
                minhasSolicitacoes: false,
                dataInicio: dataInicial,
                dataTermino: dataFinal,
            },
            {
                idProjeto,
                pagina: 1,
                titulo: '',
                descricao: '',
                responsavel: '',
                situacao: '',
                minhasSolicitacoes: true,
                dataInicio: dataInicial,
                dataTermino: dataFinal,
            },
            {
                idProjeto,
                pagina: 1,
                titulo: '',
                descricao: '',
                cliente: '',
                responsavel: usuarioLogado,
                idUsuarioAprovador: usuarioLogado,
                situacao: 'pendente',
                minhasSolicitacoes: false,
                tarefasEscritorio: false,
                tarefasAutomaticas: false,
                dataInicio: dataInicial,
                dataTermino: dataFinal,
            }
        ];

        const buscarTarefas = async () => {
            try {
                const [minhasTarefasRes, minhasSolicitacoesRes, aguardandoAprovarRes] = await Promise.all(
                    paramsList.map(params => listarTarefas(params))
                );

                if (minhasTarefasRes?.status === 200)
                    setMinhasTarefas(minhasTarefasRes.data.length);

                if (minhasSolicitacoesRes?.status === 200)
                    setMinhasSolicitacoes(minhasSolicitacoesRes.data.length);

                if (aguardandoAprovarRes?.status === 200)
                    setAguardandoAprovarTarefas(aguardandoAprovarRes.data.length);

            } catch (error) {
                console.error('Erro ao buscar tarefas:', error);
            }
        };

        buscarTarefas();

    }, [idProjeto, usuarioLogado, dataInicial, dataFinal, atualizarInformacoes]);

    return (
        <div>
            <div id='menuOpcoes' onClick={exibirSubmenu}>
                {<img id='iconeMenu' src={props.icone ? `${props.icone}` : ''} alt={props.alt}></img>}
                <p id='tituloMenu'>{props.titulo}</p>
                {(minhasTarefas + minhasTarefas) !== 0 ? <h2>{minhasTarefas + minhasSolicitacoes}</h2> : null}
            </div>
            <div id='submenuOpcoes'>
                {subMenu && <SubMenuOpcoes redirect={`/tarefas?idProjeto=${idProjeto}&grupo=${grupo}`} texto='Minhas Tarefas' notificacao={minhasTarefas === 0 ? null : minhasTarefas} />}
                {subMenu && <SubMenuOpcoes redirect={`/tarefas?minhasSolicitacoes=true&idProjeto=${idProjeto}&grupo=${grupo}`} texto='Minhas Solicitações' notificacao={minhasSolicitacoes === 0 ? null : minhasSolicitacoes} />}
                {subMenu && <SubMenuOpcoes redirect={`/tarefas?solicitacaoAprovacao=true&idProjeto=${idProjeto}&grupo=${grupo}`} texto='Aprovar Tarefas' notificacao={aguardandoAprovarTarefas === 0 ? null : aguardandoAprovarTarefas} />}
            </div>
        </div>
    )
}

export default MenuTarefas